export default {
	list: [
		{
			id: 0,
			title: "VLESS",
		},
		{
			id: 1,
			title: "Shadowsocks",
		},
		{
			id: 2,
			title: "Trojan",
		},
	],
}
